import React from 'react';
import {injectIntl} from 'react-intl';
import Alert from 'react-bootstrap/Alert';

import StarterList from '../../components/starter/StarterList';
import API from '../../common/utils/API';

export class StateList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            states: [],
            countries: [],

            // Meta Pagination
            page: 1,
            pageSize: 12,
            total: 0,

            // Search
            searchTimeout: 0,
            search: '',
            country: '',

            // Error
            error: false,

            // Loading
            loading: false,
        };
    }

    async componentDidMount() {
        await Promise.all([this.fetchStates(), this.fetchCountries()]);
    }

    fetchStates = async (pageNumber = 1) => {
        this.setState({loading: true});

        try {
            const result = await API.states.get({
                page: pageNumber,
                search: this.state.search,
                country: this.state.country,
            });

            this.setState({
                states: result.items,
                page: result.page,
                pageSize: result.pageSize,
                total: result.total,
                error: false,
                loading: false,
            });
        } catch (e) {
            this.setState(
                {
                    error: true,
                    loading: false,
                },
                this.clearErrorMessage,
            );
        }
    };

    fetchCountries = async () => {
        this.setState({loading: false});

        try {
            const {countries} = await API.countries.getAll();

            this.setState({
                countries,
                loading: false,
                error: false,
            });
        } catch (e) {
            this.setState(
                {
                    error: true,
                    loading: false,
                },
                this.clearErrorMessage,
            );
        }
    };

    clearErrorMessage = () => {
        setTimeout(() => {
            if (this.state.error) {
                this.setState({error: false});
            }
        }, 5000);
    };

    handlePageChange = (pageNumber) => {
        return this.fetchStates(pageNumber);
    };

    handleSearchKeywordChange = (event) => {
        /* istanbul ignore else */
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout);
        }

        this.setState({
            [event.target.name]: event.target.value,
            searchTimeout: setTimeout(() => {
                return this.fetchStates(1);
            }, 300),
        });
    };

    handleSearchKeywordClear = (field = 'search') => {
        this.setState(
            {
                pageSize: 1,
                [field]: '',
            },
            () => {
                return this.fetchStates(1);
            },
        );
    };

    render() {
        const countriesOptions = this.state.countries.map((country) => ({
            value: country.id,
            label: country.name,
        }));

        return (
            <div data-test='stateListComponent'>
                <Alert
                    data-test='errorAlert'
                    variant='danger'
                    className='mb-4'
                    show={this.state.error}
                >
                    <p className='mb-0'>
                        {this.props.intl.formatMessage({
                            id: 'ERROR_PAGES.LOADING_DATA',
                        })}
                    </p>
                </Alert>
                <StarterList
                    onSearchKeywordClear={this.handleSearchKeywordClear}
                    onSearchKeywordChange={this.handleSearchKeywordChange}
                    searchKeyword={this.state.search}
                    onPageChange={this.handlePageChange}
                    page={this.state.page}
                    pageSize={this.state.pageSize}
                    total={this.state.total}
                    loading={this.state.loading}
                    data={{
                        headerTitles: [
                            '#',
                            this.props.intl.formatMessage({
                                id: 'STATES.STATE_CODE_TABLE_HEADER',
                            }),
                            this.props.intl.formatMessage({
                                id: 'STATES.STATE_NAME_TABLE_HEADER',
                            }),
                            this.props.intl.formatMessage({
                                id: 'STATES.STATE_COUNTRY_TABLE_HEADER',
                            }),
                            this.props.intl.formatMessage({
                                id: 'STATES.STATE_IS_ACTIVE_TABLE_HEADER',
                            }),
                        ],
                        rows: this.state.states.map((state) => ({
                            content: [
                                state.id,
                                state.code,
                                state.name,
                                state.country,
                                state.isActive
                                    ? this.props.intl.formatMessage({
                                          id: 'GENERAL.YES',
                                      })
                                    : 'No',
                            ],
                            link: `/states/${state.id}`,
                        })),
                    }}
                    addNewPermission={'STATES_CREATE'}
                    addNewLink={`/states/create`}
                    searchFields={[
                        {
                            options: countriesOptions,
                            name: 'country',
                            placeholder: this.props.intl.formatMessage({
                                id: 'CITIES.CITY_FILTER_BY_COUNTRY_PLACEHOLDER',
                            }),
                            value: this.state.country,
                        },
                    ]}
                />
            </div>
        );
    }
}

export default injectIntl(StateList);
